(function ($) {
    const $modal = $('#order-save-modal-dialog');

    if($modal.length === 0) {
        return;
    }

    let orderPaymentStatusHasChanged = false;
    let paymentStatusHasChanged = false;

    const paymentStatusesForNotification = JSON.parse($modal.attr('data-payment-statuses'));

    const listenPaymentStatusChanges = function ($selectElement) {
        $selectElement.on('change', function () {
            if (paymentStatusesForNotification.includes(this.value)) {
                paymentStatusHasChanged = true;
            }
        });
    };

    const handleStatusChanges = function () {
        $('#payment_status').on('change', function () {
            orderPaymentStatusHasChanged = true;
        });

        $('select[name^=transaction_status]').each(function () {
            listenPaymentStatusChanges($(this));
        });
    }

    const handleNotificationsModal = function () {
        $modal.on('show.bs.modal', () => {
            const $submitBtn = $modal.find('#modal-submit-btn');

            if (paymentStatusHasChanged === false
                && orderPaymentStatusHasChanged === false) {
                $submitBtn.click();

                return false;
            }

            if (paymentStatusHasChanged) {
                $('#input-payment-notification').removeClass('d-none');
            }

            if (orderPaymentStatusHasChanged) {
                $('#input-order-notification').removeClass('d-none');
            }

            return true;
        });

        $modal.on('hidden.bs.modal', () => {
            document.querySelectorAll('#save_and_quit, #save_and_stay_on_page').forEach(button => {
                button.disabled = false;
                button.querySelector('.fa-spinner').style.display = 'none';
                button.querySelector('.fa-check').style.display = 'inline-block';
            });
        });
    }

    const newPaymentRowObserver = () => {
        const observer = new MutationObserver(mutationList => {
            for (const mutation of mutationList) {
                if (mutation.type !== 'childList') {
                    return;
                }
                if (typeof mutation.addedNodes[0] !== 'undefined'
                    && mutation.addedNodes[0].nodeName === 'TR'
                ) {
                    const $statusSelect = $(mutation.addedNodes[0]).find('select[name^=transaction_status]');
                    listenPaymentStatusChanges($statusSelect);
                }
            }
        });
        observer.observe(
            document.getElementById('order-payment-schedule'),
            {attributes: false, childList: true, subtree: true}
        );
    };

    const initTooltips = () => {
        $('[data-toggle="tooltip"]').tooltip();
    };

    const orderPaymentStatusChange = (element, refundStatuses) => {
        const value = element.value;
        const flag = refundStatuses.includes(parseInt(value));
        document.getElementById('refund_status').style.display = flag ? 'block' : 'none';
    }

    const openEditModules = (ajaxUrl) => {
        const $modal = $('#edit-offer-modal');
        $.ajax({
            url: ajaxUrl,
            dataType: 'html',
            success: (response) => {
                $modal.find('.modal-dialog').empty().append(response);
                $modal.modal('show');
            }
        });
    }

    function initButtons() {
        $('#add-new').click(addNewRow);
        $(document).on('click', '.delete', handleDelete);
        $(document).on('click', '.duplicate', handleDuplicate);
    }

    function initBanksSelect() {
        $('.bank-select2:not([aria-hidden="true"])').select2({
            tags: true,
            theme: 'bootstrap4',
            placeholder: '',
            dropdownParent: $('#order-payment-schedule'),
        });
    }

    function addNewRow() {
        $('#add-new-row tr').clone().off().find('[name]').each((_, formField) => {
            const fieldName = $(formField).attr('name');
            $(formField).attr('name', fieldName.replace('clone_', ''));
            if(fieldName.includes('_bank')) {
                $(formField).addClass('bank-select2');
            }
        }).end().appendTo('#order-payment-schedule');

        initializeRows();
    }

    function handleDelete() {
        $(this).closest('tr').remove();
        initializeRows();
    }

    function removeSelect2($field) {
        let selectedValue = $field.parent()
            .find('span.select2-selection__rendered')
            .text();

        $field.find('option').removeAttr('data-select2-id');

        $field.removeClass('select2-hidden-accessible')
            .removeAttr('data-select2-id tabindex aria-hidden');

        $field.val(selectedValue);
    }

    function handleDuplicate() {
        $(this).closest('tr')
            .clone()
            .off()
            .removeAttr('data-select2-id')
            .find('[name]')
            .each((_, formField) => {
                const $field = $(formField);
                $field.attr('name', $field.attr('name').replace(/\[\d+]/, '[]'));

                if ($field.attr('name').includes('check_number') && /^\d{7}$/.test($field.val())) {
                    $field.val(parseInt($field.val()) + 1);
                }

                if ($field.hasClass('select2-hidden-accessible')) {
                    removeSelect2($field);
                }
            })
            .end()
            .find('span.select2').remove()
            .end()
            .insertAfter($(this).closest('tr'));

        initializeRows();
    }

    function initializeRows() {
        const $tbody = $('#order-payment-schedule tbody');
        $tbody.find('#no-payment-msg').remove();
        $tbody.find('tr').each((idx, row) => $(row).find('td:first-child').html(idx + 1));
        initBanksSelect();
    }

    function reloadTransactions(ajaxUrl) {
        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            data: {
                _token: $('meta[name="csrf-token"]').attr('content'),
            },
            dataType: 'json',
            success: (response) => {
                if (response.status === 'ERROR') {
                    Swal.fire({
                        icon: 'error',
                        title: 'Une erreur est survenue',
                        text: response.msg.errorCode ?? response.msg,
                        confirmButtonColor: "#3085d6",
                    });

                } else {
                    location.reload();
                }
            }
        });
    }

    function cancelPayment(ajaxUrl) {
        Swal.fire({
            title: 'Êtes-vous sûr de vouloir annuler ce paiment?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Oui',
            denyButtonText: 'Non',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        }).then((confirmed) => {
            if (confirmed.value !== true) {
                return;
            }
            $.ajax({
                url: ajaxUrl,
                type: 'POST',
                data: {
                    _token: $('meta[name="csrf-token"]').attr('content'),
                },
                dataType: 'json',
                success: (response) => {
                    if (response.status === 'ERROR') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Une erreur est survenue',
                            text: response.msg.errorCode ?? response.msg,
                            confirmButtonColor: "#3085d6",
                        });
                    } else {
                        location.reload();
                    }
                }
            });
        });
    }

    function generateCreditInvoice(ajaxUrl, refund) {
        console.log(refund);
        Swal.fire({
            title: 'Générer une facture d\'avoir',
            html: `Remboursement de
                ${Math.abs(parseFloat(refund.amount).toString())}€
                <br> en date du ${refund.date}`,
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Oui',
            denyButtonText: 'Non',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        }).then((confirmed) => {
            if (confirmed.value !== true) {
                return;
            }
            $.ajax({
                url: ajaxUrl,
                type: 'POST',
                data: {
                    _token: $('meta[name="csrf-token"]').attr('content'),
                },
                dataType: 'json',
                success: (response) => {
                    if (response.status === 'ERROR') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Une erreur est survenue',
                            text: response.msg.errorCode ?? response.msg,
                            confirmButtonColor: "#3085d6",
                        });
                    } else {
                        location.reload();
                    }
                }
            });
        });
    }

    initTooltips();
    initButtons();
    initBanksSelect();
    handleStatusChanges();
    handleNotificationsModal();
    newPaymentRowObserver();

    window.openEditModules = openEditModules;
    window.orderPaymentStatusChange = orderPaymentStatusChange;
    window.reloadTransactions = reloadTransactions;
    window.cancelPayment = cancelPayment;
    window.generateCreditInvoice = generateCreditInvoice;
})($);
